import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { usePopover } from "@website/ui/popover/popover.hook";
import styles from "@website/ui/popover/popover.module.scss";
import { PopoverPropertiesType } from "@website/ui/popover/popover.types";
import { TransitionV2 } from "@website/ui/transition";
import { FC, memo } from "react";

const Popover: FC<PopoverPropertiesType> = (properties) => {
  const {
    animate = "bottom",
    children,
    hideCloseButton,
    title,
    gap,
    horizontalPosition = "start",
    verticalPosition,
    className,
    headerClassName
  } = properties;
  const { isMobile } = useViewPort();
  const {
    rootProps,
    transitionProps,
    closeButtonProps,
    popoverOpen,
    animateOpen
  } = usePopover(properties);

  if (popoverOpen) {
    return (
      <TransitionV2 {...transitionProps} in={animateOpen}>
        {(state: string) => (
          <div
            {...rootProps}
            className={`${styles["popover"]} ${styles[animate]} ${styles[state]} ${styles[horizontalPosition]} ${styles[verticalPosition]} ${className}`}
            style={{ marginTop: isMobile ? "0px" : gap || "0px" }}
          >
            <div className={`${styles["header"]} ${headerClassName}`}>
              {title ? <div className={styles["title"]}>{title}</div> : null}
              {hideCloseButton ? null : (
                <div className={styles["close-wrapper"]}>
                  <MaterialIcon
                    className={styles["close-button"]}
                    name="close"
                    {...closeButtonProps}
                  />
                </div>
              )}
            </div>
            {children}
          </div>
        )}
      </TransitionV2>
    );
  }
  return null;
};

const PopoverMemoized = memo(Popover);
export { PopoverMemoized as Popover };
